<template>
    <section class="valuation-layout  container" id="vehicle-walkaround">
        <h1 class="valuation-layout__header">Free Instant Vehicle Valuation</h1>
        <StepBar />
        <StepLink :step="step - 1" />

        <div class="valuation-layout__container">
            <valuation-amount v-if="valuation" :show-cta="false"
                valuation-title="Your Estimated Vehicle Valuation"
                valuation-text="Share some vehicle images with us for even greater accuracy">
            </valuation-amount>

            <div class="valuation-layout__car-image-container valuation-vehicle-details__car-image-container">
                <div class="valuation-vehicle-details__img-area">
                    <img class="img-responsive valuation-vehicle-details__starburst" src="/images/configurator/stellantis-starburst.svg" alt="Stellantis Starburst">
                    <img class="valuation-vehicle-details__vehicle" :src="vehicleImage" alt="Car Image" />
                    <p class="valuation-vehicle-details__illustrative-message">Image for illustrative purposes only</p>
                </div>
            </div>

            <div class="valuation-layout__main-section">
                <h3 v-if="!tchekImages.completed" class="valuation-layout__title">Send us your vehicle imagery</h3>
                <h3 v-else class="valuation-layout__title">Thank you for uploading your vehicle imagery</h3>
                <p></p>
                <div class="rd-card rd-card--border-top  valuation-layout__card">
                    <div class="valuation-layout__condition-container" v-if="!tchekImages.completed">
                        <!-- <p>With our quick and easy to use imagery tool you can scan your vehicle, the images will then be used to provide a more accurate valuation. Please add your phone number below to receive a personalised link or scan the QR code.</p> -->
                        <p v-if="!isDealer">With our quick and easy to use imagery tool you can scan your vehicle, the images will then be used to provide a more accurate valuation.</p>
                        <div v-else>
                            <p>Capture images of the vehicle using a phone or tablet. Scan the QR code to continue on another device, or start instantly using the button below on this device if it has a camera.</p>
                            <a @click="openTchek" class="btn btn--primary card__button vehicle-walkaround__tcheck-button">
                                Scan Vehicle
                            </a>
                            <p>If you would like the customer to take the photos of the car for you, use the form below to send them an SMS. This will allow the customer to take and submit the photos, but please note: the customer will not see the updated valuation — only you as the dealer will have access to it.</p>
                        </div>
                        <form @submit.prevent="sendTchekSms" id="logged-in" ref="form" method="post" class="form-grid form-grid--xs-1-column material-form details-form summary__form" data-form-name="Valuation - Your Details" style="position: relative;">
                            <div class="form-element__container">
                                <div class="vehicle-walkaround__phone-input">
                                    <div>
                                        <input v-model="vehicleImagery.phone" type="tel" data-validate="tel"
                                        data-validate-message="Please enter mobile number" name="telephone"
                                        autocomplete="off" class="form-element__input"
                                        placeholder="Telephone *">
                                    </div>
                                    <div>
                                        <div v-if="dontShowTick === false && vehicleImagery.messageSentState === true">
                                            <img src="/images/valuation-tool/not-my-vehicle/green-tick.svg" alt="" class="vehicle-walkaround__success--icon" />
                                        </div>
                                        <div v-else-if="vehicleImagery.messageSentState === false"></div>
                                        <div v-else></div>
                                    </div>
                                </div>

                                <button v-if="vehicleImagery.messageSentState === false" class="link link--primary link--is-button link--has-icon vehicle-walkaround__resend">
                                    <span v-if="vehicleImagery.messageSentCount > 0">
                                        Resend
                                    </span>
                                    <span v-else>
                                        Send
                                    </span>
                                </button>
                            </div>

                            <qr-code v-if="vehicleImagery.TchekUrl" :qrData="vehicleImagery.TchekUrl" />
                        </form>

                        <h3 class="valuation-layout__label">Unable to use a smart phone?</h3>
                        <p class="vehicle-walkaround__paragraph-text">
                            If you're unable to access a smartphone, we recommend using a friend or family member's to capture your vehicle imagery and receive an exact valuation for your vehicle.
                        <br>
                        <br>
                            If you're still unable to access a smartphone, <a href="#" @click.prevent="goToBookAppointment"> book an appointment </a>at your local dealership and an expert sales advisor will appraise your vehicle.
                        </p>

                        <h3 class="valuation-layout__label">Summary</h3>
                        <p class="vehicle-walkaround__paragraph-text">A summary of your vehicle imagery will be displayed once you have submitted your photography. </p>
                    </div>
                    <div class="valuation-layout__condition-container" v-else>
                        <h3 class="valuation-layout__label">Summary</h3>
                        <p>We have received the following imagery of your vehicle and have updated your valuation.</p>
                        <div class="vehicle-walkaround__image-gallery">
                            <div v-if="tchekImages && tchekImages.damaged">
                                <h3 class="valuation-layout__label">The following images have been marked as showing damage:</h3>
                                <div class="vehicle-walkaround__image-gallery--damaged">
                                    <TchekSummaryGallery
                                        :tchekImages="tchekImages.damaged"
                                    />
                                </div>
                            </div>
                            <div v-if="tchekImages && tchekImages.inspectedImages">
                                <h3 class="valuation-layout__label">Summary of all images taken:</h3>
                                <div class="vehicle-walkaround__image-gallery--all">
                                    <TchekSummaryGallery
                                        :tchekImages="tchekImages.inspectedImages"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="valuation-layout__button-area">
                        <button v-if="tchekImages.completed" type="button" class="btn btn--primary card__button valuation-layout__button" @click.prevent="submit">
                            <span>Continue</span>
                        </button>
                        <a v-if="authenticated" href="/my-account/valuations" target="_blank"   class="link  link--primary   link--has-icon valuation-layout__button">
                            Save Progress To My Account
                        </a>
                        <a v-else href="#" class="link link--primary  link--has-icon valuation-layout__button" @click.prevent="registerAndSave">
                            Save Progress To My Account
                        </a>
                    </div>
                </div>
            </div>
            <div class="valuation-layout__vehicle-details">
                <VehicleDetails :displayImage="false"/>
                <button @click="newValuation()" class="btn  btn--full-width btn--primary-inverted ">Start new valuation</button>
            </div>
        </div>
    </section>
</template>

<script>
import Pusher from "pusher-js";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { StepBar, StepLink, ValuationAmount, VehicleDetails, QrCode } from "../";
import TchekSummaryGallery from "../Sections/TchekSummaryGallery.vue";


export default {
    components: {
        VehicleDetails,
        StepBar,
        StepLink,
        ValuationAmount,
        QrCode,
        TchekSummaryGallery
    },
    data() {
        return {
            channel: false,
            validator: false,
            images:null,
            damagedImages:null,
            dontShowTick:false
        };
    },
    methods: {
        ...mapActions("ValuationExtended", ["sendTchekImagerySms", "saveAndContinue", "registerAndSave", "goToBookAppointment", "getTchekImages", "openTchekUrl"]),
        ...mapActions("ValuationTool", ["goToPosition", "newValuation" ]),
        ...mapMutations("ValuationTool", ["setValuationFinalAmount"]),
        ...mapMutations("ValuationExtended", ["setTchekImages"]),

        submit(){
            this.saveAndContinue();
        },

        openTchek(){
            // if(this.vehicleImagery.RequestUrl.indexOf("car-valuation") != -1){
                window.location.href = this.vehicleImagery.TchekUrl
            // }else{
            //     window.open(this.vehicleImagery.TchekUrl, '_blank')
            // }
        },

        async sendTchekSms() {
            if (!await this.validator.isValid()) {
                this.validator.scrollToFirstError();
                return;
            }

            this.validator.errorResponse();

            const formData = new FormData(this.$refs['form']);

            this.sendTchekImagerySms(formData)
                .catch(errorData => {
                    if (errorData.errors) {
                        if (errorData.errors.sms_count) {
                            this.dontShowTick = true
                            const modifiedErrors = {
                                errors: {
                                    telephone: errorData.errors.sms_count
                                }
                            };
                            this.validator.errorResponse(modifiedErrors);
                        } else {
                            this.validator.errorResponse(errorData);
                        }
                        this.validator.scrollToFirstError();
                    } else {
                        this.validator.errorResponse(errorData);
                    }
                });
        },


        connectPusherChannel() {
            if (this.pusher == null) {
                this.pusher = new Pusher(process.env.MIX_PUSHER_APP_KEY, {
                    cluster: "eu",
                    forceTLS: true,
                });
            }
            this.channel = this.pusher.subscribe('valuation-updates-' + this.valuationLogId);
            this.channel.bind("valuation-updated", (data) => {
                this.getTchekImages()
                this.setValuationFinalAmount(data.valuation)
            });
        },
    },

    computed: {
        ...mapState('ValuationTool', ['step', 'valuation', 'isDealer']),
        ...mapState('ValuationExtended', ['vehicleImagery', 'valuationLogId']),
        ...mapState('Auth', ['authenticated']),
        ...mapGetters('ValuationTool', ['vehicleImage']),
        ...mapGetters('ValuationExtended', ['tchekImages']),

        formattedTchekUrl(){
            const urlParams = new URLSearchParams(window.location.search);
            let tchekUrl = this.vehicleImagery.TchekUrl
            if(urlParams.has('valuation')){
                tchekUrl = `${this.vehicleImagery.TchekUrl}?account=true`;
            }
            return tchekUrl;
        }
    },
    mounted() {
        this.goToPosition('valuation-start')
        this.validator = new ContactFormValidator({
            element: this.$refs['form'],
            vueForm: true,
            redesign: true,
        });
    },
    created(){
        this.connectPusherChannel();
    }
}
</script>